module.exports = __webpack_public_path__ + "img/creditcard.34262682.svg";